/**
 * Liest einen Cookie-Wert aus `document.cookie`.
 *
 * Bewusst synchron und ohne CookieStore-API: Der Wert wird in synchronem Kontext
 * gebraucht, und alte Engines (Chromium 61 auf eReadern) kennen `cookieStore` nicht.
 *
 * @param {string} name - Name des Cookies
 * @returns {string|undefined} Wert des Cookies oder undefined, wenn es ihn nicht gibt
 */
export default function readCookie(name) {
    if (typeof document === 'undefined') {
        return undefined;
    }

    const prefix = `${name}=`;
    const cookies = document.cookie.split(';');

    for (const cookie of cookies) {
        const trimmed = cookie.trim();
        if (trimmed.indexOf(prefix) === 0) {
            return decodeURIComponent(trimmed.substring(prefix.length));
        }
    }

    return undefined;
}
